import http from '@/api'
import { COSPATH } from '../config'
import * as types from './mutations-types'

export default {
  async [types.INIT_BASE_DATA]({ commit }) {
    // 用户信息
    http.userInfo().then(res => {
      console.log('// 用户信息')
      commit('SET_USERINFO', res.data.data)
    })
    // 微信配置
    await http.getWxConfig().then(res => {
      console.log('// 微信配置', res.data.data)
      commit('SET_WXCONFIG', res.data.data)
    })
    // 分享配置
    await http.getShareConfig().then(res => {
      console.log('// 分享配置')
      let { title, description, url, image } = res.data.data
      const config = { title, desc: description, link: url, imgUrl: COSPATH + image }
      commit('SET_SHARECONFIG', config)
    })
    // 是否关注
    await http.getFollowConfig().then(res => {
      console.log('// 是否关注')
      commit('SET_FOLLOWCONFIG', res.data.data)
    })
  },
  [types.SET_VIP_CONFIG]({ commit }) {
    http.pageVip().then(res => {
      commit(types.SET_VIP_CONFIG, res.data.data.list.length > 0 ? true : false)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js